import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);

  return (
    <div className="min-h-screen" style={{ background: 'var(--dash-bg)', color: 'var(--dash-text)', fontFamily: "'Inter', sans-serif" }}>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Sidebar open={sidebarOpen} onToggle={toggleSidebar} />

      <style>{`
        .dash-main { margin-left: 260px; }
        @media (max-width: 1023px) { .dash-main { margin-left: 0; } }
      `}</style>

      <div className="dash-main flex flex-col min-h-screen">
        <Navbar onToggleSidebar={toggleSidebar} />

        <main id="main-content" tabIndex={-1} className="flex-1 overflow-y-auto px-6 lg:px-8 py-6 space-y-6 outline-none">
          <Outlet />
        </main>

        <footer
          className="shrink-0 px-6 lg:px-8 py-3 text-center text-xs"
          style={{ color: 'var(--dash-text4)', borderTop: '1px solid var(--dash-border)' }}
        >
          © {new Date().getFullYear()} ScheduleX. All rights reserved.
        </footer>
      </div>
    </div>
  );
}
